var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"float-msg"},[_c('span',{staticClass:"float-interval"},[_vm._v(_vm._s(_vm.selInterval))]),_c('span',{staticClass:"float-duration"},[_vm._v(_vm._s(_vm.selDuration))])])}
var staticRenderFns = []

export { render, staticRenderFns }